export default "__VITE_ASSET__Jen5qG6H__"